import React from "react";
import { MessageCircle } from "lucide-react";
import { siteConfig, whatsappLink } from "../mock";

const ContactCTA = () => {
  return (
    <section
      className="relative w-full min-h-[560px] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.55)), url(${siteConfig.ctaImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="relative z-10 w-full max-w-[1100px] px-6 text-center py-24">
        <h2
          className="text-white mb-6"
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "clamp(38px, 5vw, 64px)",
            fontWeight: 400,
            letterSpacing: "-0.5px",
          }}
        >
          {siteConfig.ctaTitle}
        </h2>
        <p
          className="text-white/95 mb-8"
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "clamp(16px, 1.2vw, 20px)",
            fontWeight: 700,
          }}
        >
          {siteConfig.ctaSubtitle}
        </p>

        <a
          href={whatsappLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-white text-[15px] font-medium tracking-wide shadow-lg hover:shadow-xl transform-gpu hover:-translate-y-[1px] transition-all duration-200"
          style={{ backgroundColor: "#3d4a1f" }}
        >
          <MessageCircle className="w-[18px] h-[18px]" />
          <span>Whatsapp Now</span>
        </a>
      </div>
    </section>
  );
};

export default ContactCTA;
